import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import TeacherWorkload from './TeacherWorkload';
import TeacherDailyReport from './TeacherDailyReport';
import ExpenseReports from './ExpenseReports';
import FeeReports from './FeeReports';
import AcademicPerformance from './AcademicPerformance';

interface AnalyticsModuleProps {
  domain: string;
  onBack: () => void;
}

const AnalyticsModule: React.FC<AnalyticsModuleProps> = ({ domain, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('workload');

  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/daily-reports')) setActiveTab('daily-reports');
    else if (path.includes('/expenses')) setActiveTab('expenses');
    else if (path.includes('/fees')) setActiveTab('fees');
    else if (path.includes('/academic')) setActiveTab('academic');
    else setActiveTab('workload');
  }, [location.pathname]);

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-primary-custom text-white p-3 shadow-sm">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            <i className="bi bi-graph-up-arrow me-2"></i>
            Analytics & Reports
          </h4>
          <button className="btn btn-light btn-sm" onClick={onBack}>
            <i className="bi bi-arrow-left me-2"></i>Back to Dashboard
          </button>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white shadow-sm">
        <div className="container-fluid">
          <ul className="nav nav-tabs border-0 flex-nowrap overflow-auto">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'workload' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/analytics')}
              >
                <i className="bi bi-person-workspace me-2"></i>Teacher Workload
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'daily-reports' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/analytics/daily-reports')}
              >
                <i className="bi bi-journal-text me-2"></i>Daily Reports
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'expenses' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/analytics/expenses')}
              >
                <i className="bi bi-receipt me-2"></i>Expense Reports
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'fees' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/analytics/fees')}
              >
                <i className="bi bi-currency-rupee me-2"></i>Fee Reports
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'academic' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/analytics/academic')}
              >
                <i className="bi bi-mortarboard me-2"></i>Academic Performance
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Content Area */}
      <div className="container-fluid py-4">
        <Routes>
          <Route index element={<TeacherWorkload domain={domain} />} />
          <Route path="daily-reports" element={<TeacherDailyReport domain={domain} />} />
          <Route path="expenses" element={<ExpenseReports domain={domain} />} />
          <Route path="fees" element={<FeeReports domain={domain} />} />
          <Route path="academic" element={<AcademicPerformance domain={domain} />} />
        </Routes>
      </div>
    </div>
  );
};

export default AnalyticsModule;
